// src/App.js

import React, { useEffect } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import PrivateRoute from './routes/PrivateRoute'
import './i18n' 
import { useTranslation } from 'react-i18next'
import Navbar from './components/Navbar'

// Sayfalar
import WorkspacePage from './pages/WorkspacePage'
import ChannelsPage from './pages/ChannelsPage'
import AdminWorkspaces from './pages/AdminWorkspaces'
import Profile from './pages/Profile'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'

// Yeni Sayfalar
import ModeratorFormBuilder from './pages/ModeratorFormBuilder'
import UserAnswersPage from './pages/UserAnswersPage'
import DashboardPage from './pages/DashboardPage'
import ToDoPage from './pages/ToDoPage'
import AdminUsersPage from './pages/AdminUsersPage' // <-- yeni sayfa import'u
import CardReportingPage from './pages/CardReportingPage' 
import AIReportingPage from './pages/AIReportingPage' 
import CardAnalyticsPage from './pages/CardAnalyticsPage' 



function App() {
  const { i18n } = useTranslation()

  // Dil değiştiğinde document lang özelliğini güncelleyin
  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          {/* Public routes: kimliklendirme sayfaları */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Private routes */}
          <Route
            path="/workspaces"
            element={
              <PrivateRoute>
                <WorkspacePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/workspace/:workspaceId"
            element={
              <PrivateRoute>
                <ChannelsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          {/* Admin route */}
          <Route
            path="/admin-workspaces"
            element={
              <PrivateRoute adminOnly>
                <AdminWorkspaces />
              </PrivateRoute>
            }
          />

          {/* Yeni Route'lar */}
          <Route
            path="/moderator/questions"
            element={
              <PrivateRoute >
                <ModeratorFormBuilder />
              </PrivateRoute>
            }
          />
          <Route
            path="/user/answers"
            element={
              <PrivateRoute>
                <UserAnswersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/view-answers"
            element={
              <PrivateRoute >
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/view-answers-card"
            element={
              <PrivateRoute >
                <CardReportingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/aireports"
            element={
              <PrivateRoute >
                <AIReportingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/todolist"
            element={
              <PrivateRoute>
                <ToDoPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/CardAnalyticsPage"
            element={
              <PrivateRoute>
                <CardAnalyticsPage />
              </PrivateRoute>
            }
          />


          {/* Yeni: Kullanıcı Yönetimi rotası */}
          <Route
            path="/admin-users"
            element={
              <PrivateRoute adminOnly>
                <AdminUsersPage />
              </PrivateRoute>
            }
          />

          {/* Root: Varsayılan olarak workspaces yönlendirmesi */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <ToDoPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App